import React, { useState, useEffect } from "react";
import { Modal, Box, TextField, Button, Typography, Table, TableBody, IconButton, TableCell, TableContainer, TableHead, TableRow, Grid, useTheme, CircularProgress } from "@mui/material";
import { tokens } from "../../theme/theme";
import { callApi } from "../../utils/apiClient";
import { API_ENDPOINTS } from "../../config/api/apiCall";
import Close from '@mui/icons-material/Close';
import CustomTableContainer from "../../Layout/CustomTableContainer";
// import useUserPermissions from "../../components/user-permission/UserPermission";

const AddRemarks = ({
    onClose,
    handleBackWinderMachineEntry,
    handleClose,
    moduleName,
    parentModuleName,
    open,
    userPermissions = [], // 👈 ensures it’s always an array
}) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    // const userPermissions = useUserPermissions();

    const [remark, setRemark] = useState('');
    const [remarksList, setRemarksList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [saveLoading, setSaveLoading] = useState(false);


   const moduledetails = (userPermissions || []).find(
    (m) =>
        m.module_name === moduleName &&
        m.parent_module_name === parentModuleName
) || {};  // 👈 ensures moduledetails is at least an empty object

const effectiveModuleId = moduledetails.module_id ?? 9;
const effectiveParentModuleId = moduledetails.parent_module_id ?? 6;
    // Use default values if props are null or undefined
    // const effectiveModuleId = moduledetails.module_id ?? 9;
    // const effectiveParentModuleId = moduledetails.parent_module_id ?? 6;



    const fetchRemarks = async () => {
        setLoading(true);
        const dataToFetch = {
            parent_module_id: effectiveParentModuleId,
            module_id: effectiveModuleId,
        };
        try {
            const data = await callApi(API_ENDPOINTS.MASTER_GET_REMARKS, 'POST', { 'Content-Type': 'application/json' }, dataToFetch);
            if (data) {
                setRemarksList(data);
            } else {
                setRemarksList([]);
            }
        } catch (error) {
            console.error("Failed to fetch remarks:", error);
            setRemarksList([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (open) {
            fetchRemarks();
        }
    }, [open, effectiveModuleId, effectiveParentModuleId]);

    const handleSave = async () => {
        if (remark.trim() === '') {
            alert("Remarks cannot be empty.");
            return;
        }

        setSaveLoading(true);

        const companyId = localStorage.getItem('companyid');
        const createdBy = localStorage.getItem('useremail');

        const dataToSave = {
            description: remark.trim(),
            parent_module_id: effectiveParentModuleId,
            module_id: effectiveModuleId,
            company_id: companyId,
            plant_id: 1,
            created_by: createdBy,
        };

        try {
            const response = await callApi(API_ENDPOINTS.MASTER_SAVE_REMARKS, 'POST', {
                'Content-Type': 'application/json'
            }, dataToSave);

            if (response) {
                console.log("Saving remark:", remark);
                await fetchRemarks();
                setRemark('');
            } else {
                console.error("Failed to save remark. API returned an error.");
            }
        } catch (error) {
            console.error("API Error:", error);
        } finally {
            setSaveLoading(false);
        }
    };

    return (
        <Modal open={open} onClose={onClose} >
            <Box
                style={{ backgroundColor: colors.primary[600], color: colors.primary }}
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 600,
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: '10px',
                    color: colors.grey[100],
                }}
            >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Typography variant="h4">Add Remarks</Typography>
                    <IconButton onClick={onClose}>
                        <Close fontSize="inherit" style={{ color: "#2196F3", fontSize: "18px" }} onClick={handleClose} />
                    </IconButton>
                </Box>

                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={9}>
                        <TextField
                            label="Remarks"
                            variant="outlined"
                            fullWidth
                            size="small"
                            value={remark}
                            color="secondary"
                            onChange={(e) => setRemark(e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={handleSave}
                            fullWidth
                            disabled={saveLoading}
                        >
                            {saveLoading ? <CircularProgress size={24} /> : 'Save'}
                        </Button>
                    </Grid>
                </Grid>

                <Typography variant="h5" mt={3} mb={1}>Remarks List</Typography>

                <CustomTableContainer colors={colors}>

                    <TableContainer sx={{ maxHeight: 400 }}>
                        <Table size="small" stickyHeader>
                            <TableHead sx={{ backgroundColor: colors.primary[400] }}>
                                <TableRow>
                                    <TableCell >SNo</TableCell>
                                    <TableCell>Remarks</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {loading ? (
                                    <TableRow>
                                        <TableCell colSpan={2} align="center">
                                            <CircularProgress size={24} />
                                        </TableCell>
                                    </TableRow>
                                ) : remarksList.length > 0 ? (
                                    remarksList.map((item, index) => (
                                        <TableRow key={item.remarks_id}>
                                            <TableCell >{index + 1}</TableCell>
                                            <TableCell>{item.description}</TableCell>
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={2} align="center">
                                            No remarks found.
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </CustomTableContainer>
            </Box>
        </Modal>
    );
};

export default AddRemarks;